var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8606 12.662H8.16162V14.361H9.8606V12.662Z",
    fill: "#FF6F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8606 9.04593H8.16162V10.7449H9.8606V9.04593Z",
    fill: "#FF6F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4768 12.662H11.7778V14.361H13.4768V12.662Z",
    fill: "#FF6F00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23365 12.662H4.53467V14.361H6.23365V12.662Z",
    fill: "#FF6F00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0599 0.90688H14.3724V0H12.6735V0.90688H5.32653V0H3.62755V0.90688H1.94005C0.872449 0.90688 0 1.77933 0 2.84693V16.0485C0 17.1161 0.872449 17.9885 1.94005 17.9885H16.0599C17.1276 17.9885 18 17.1161 18 16.0485V2.84693C18 1.77933 17.1276 0.90688 16.0599 0.90688ZM16.301 16.0485C16.301 16.1862 16.1977 16.2895 16.0599 16.2895H1.95153C1.81378 16.2895 1.71046 16.1862 1.71046 16.0485V7.3699C1.71046 7.23214 1.81378 7.12882 1.95153 7.12882H16.0599C16.1977 7.12882 16.301 7.23214 16.301 7.3699V16.0485ZM16.301 5.18878C16.301 5.32654 16.1977 5.42984 16.0599 5.42984H1.95153C1.81378 5.42984 1.71046 5.32654 1.71046 5.18878V2.60587H3.63903V3.51275H5.33801V2.60587H12.6849V3.51275H14.3839V2.60587H16.3125V5.18878H16.301Z",
    fill: "#FF6F00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4768 9.04593H11.7778V10.7449H13.4768V9.04593Z",
    fill: "#FF6F00"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOff);
export default __webpack_public_path__ + "static/media/time_off.17b494d56dfe937320f2145318d6b033.svg";
export { ForwardRef as ReactComponent };